import React from 'react';

import * as S from './styled';

const Item = props => {

  let icon = '';

  if (props.to === '/register') {
    icon = <S.AddIcon />
  }
  if (props.to === '/search') {
    icon = <S.SearchIcon />
  }
  if (props.to === '/signup') {
    icon = <S.AddUs />
  }
  if (props.to === '/report') {
    icon = <S.ReportIcon />
  }
  return (
      <S.LinkItem to={ props.to }>
      <S.LinkIcon>
        { icon }
      </S.LinkIcon>
      <S.LinkText>{ props.children }</S.LinkText>
    </S.LinkItem>
  )
};

export default Item;